import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _toConsumableArray from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { EventTarget } from '../event-target';
import { ACTIVE_AUDIO_NODE_STORE, AUDIO_NODE_STORE, AUDIO_PARAM_AUDIO_NODE_STORE, AUXILIARY_GAIN_NODE_STORE, EVENT_LISTENERS } from '../globals';
import { isAudioNode } from '../guards/audio-node';
import { isAudioNodeOutputConnection } from '../guards/audio-node-output-connection';
import { isAudioWorkletNode } from '../guards/audio-worklet-node';
import { isDelayNode } from '../guards/delay-node';
import { cacheTestResult } from '../helpers/cache-test-result';
import { connectNativeAudioNodeToNativeAudioNode } from '../helpers/connect-native-audio-node-to-native-audio-node';
import { deleteEventListenerOfAudioNode } from '../helpers/delete-event-listeners-of-audio-node';
import { disconnectNativeAudioNodeFromNativeAudioNode } from '../helpers/disconnect-native-audio-node-from-native-audio-node';
import { getAudioGraph } from '../helpers/get-audio-graph';
import { getAudioNodeConnections } from '../helpers/get-audio-node-connections';
import { getAudioParamConnections } from '../helpers/get-audio-param-connections';
import { getEventListenersOfAudioNode } from '../helpers/get-event-listeners-of-audio-node';
import { getNativeAudioNode } from '../helpers/get-native-audio-node';
import { getNativeAudioParam } from '../helpers/get-native-audio-param';
import { getNativeContext } from '../helpers/get-native-context';
import { getValueForKey } from '../helpers/get-value-for-key';
import { insertElementInSet } from '../helpers/insert-element-in-set';
import { isActiveAudioNode } from '../helpers/is-active-audio-node';
import { isPassiveAudioNode } from '../helpers/is-passive-audio-node';
import { pickElementFromSet } from '../helpers/pick-element-from-set';
import { setInternalState } from '../helpers/set-internal-state';
import { setInternalStateToPassiveWhenNecessary } from '../helpers/set-internal-state-to-passive-when-necessary';
import { testAudioNodeDisconnectMethodSupport } from '../support-testers/audio-node-disconnect-method';
import { wrapAudioNodeDisconnectMethod } from '../wrappers/audio-node-disconnect-method';

var addAudioNode = function addAudioNode(context, audioNode, audioNoderRender, nativeAudioNode) {
  var audioGraph = getAudioGraph(context);
  var activeInputs = [];

  for (var i = 0; i < nativeAudioNode.numberOfInputs; i += 1) {
    activeInputs.push(new Set());
  }

  var audioNodeConnections = {
    activeInputs: activeInputs,
    outputs: new Set(),
    passiveInputs: new WeakMap(),
    renderer: audioNoderRender
  };
  audioGraph.nodes.set(audioNode, audioNodeConnections);
};

var addActiveInputConnectionToAudioNode = function addActiveInputConnectionToAudioNode(activeInputs, source, _ref, ignoreDuplicates) {
  var _ref2 = _slicedToArray(_ref, 3),
      output = _ref2[0],
      input = _ref2[1],
      eventListener = _ref2[2];

  insertElementInSet(activeInputs[input], [source, output, eventListener], function (activeInputConnection) {
    return activeInputConnection[0] === source && activeInputConnection[1] === output;
  }, ignoreDuplicates);
};

var addActiveInputConnectionToAudioParam = function addActiveInputConnectionToAudioParam(activeInputs, source, _ref3, ignoreDuplicates) {
  var _ref4 = _slicedToArray(_ref3, 2),
      output = _ref4[0],
      eventListener = _ref4[1];

  insertElementInSet(activeInputs, [source, output, eventListener], function (activeInputConnection) {
    return activeInputConnection[0] === source && activeInputConnection[1] === output;
  }, ignoreDuplicates);
};

var deleteActiveInputConnectionToAudioNode = function deleteActiveInputConnectionToAudioNode(activeInputs, source, output, input) {
  return pickElementFromSet(activeInputs[input], function (activeInputConnection) {
    return activeInputConnection[0] === source && activeInputConnection[1] === output;
  });
};

var deleteActiveInputConnectionToAudioParam = function deleteActiveInputConnectionToAudioParam(activeInputs, source, output) {
  return pickElementFromSet(activeInputs, function (activeInputConnection) {
    return activeInputConnection[0] === source && activeInputConnection[1] === output;
  });
};

var addPassiveInputConnectionToAudioNode = function addPassiveInputConnectionToAudioNode(passiveInputs, input, _ref5, ignoreDuplicates) {
  var _ref6 = _slicedToArray(_ref5, 3),
      source = _ref6[0],
      output = _ref6[1],
      eventListener = _ref6[2];

  var passiveInputConnections = passiveInputs.get(source);

  if (passiveInputConnections === undefined) {
    passiveInputs.set(source, new Set([[output, input, eventListener]]));
  } else {
    insertElementInSet(passiveInputConnections, [output, input, eventListener], function (passiveInputConnection) {
      return passiveInputConnection[0] === output && passiveInputConnection[1] === input;
    }, ignoreDuplicates);
  }
};

var addPassiveInputConnectionToAudioParam = function addPassiveInputConnectionToAudioParam(passiveInputs, _ref7, ignoreDuplicates) {
  var _ref8 = _slicedToArray(_ref7, 3),
      source = _ref8[0],
      output = _ref8[1],
      eventListener = _ref8[2];

  var passiveInputConnections = passiveInputs.get(source);

  if (passiveInputConnections === undefined) {
    passiveInputs.set(source, new Set([[output, eventListener]]));
  } else {
    insertElementInSet(passiveInputConnections, [output, eventListener], function (passiveInputConnection) {
      return passiveInputConnection[0] === output;
    }, ignoreDuplicates);
  }
};

var deletePassiveInputConnectionToAudioNode = function deletePassiveInputConnectionToAudioNode(passiveInputs, source, output, input) {
  var passiveInputConnections = getValueForKey(passiveInputs, source);
  var matchingConnection = pickElementFromSet(passiveInputConnections, function (passiveInputConnection) {
    return passiveInputConnection[0] === output && passiveInputConnection[1] === input;
  });

  if (passiveInputConnections.size === 0) {
    passiveInputs.delete(source);
  }

  return matchingConnection;
};

var deletePassiveInputConnectionToAudioParam = function deletePassiveInputConnectionToAudioParam(passiveInputs, source, output) {
  var passiveInputConnections = getValueForKey(passiveInputs, source);
  var matchingConnection = pickElementFromSet(passiveInputConnections, function (passiveInputConnection) {
    return passiveInputConnection[0] === output;
  });

  if (passiveInputConnections.size === 0) {
    passiveInputs.delete(source);
  }

  return matchingConnection;
};

var addConnectionToAudioNodeOfAudioContext = function addConnectionToAudioNodeOfAudioContext(source, destination, output, input) {
  var _getAudioNodeConnecti = getAudioNodeConnections(destination),
      activeInputs = _getAudioNodeConnecti.activeInputs,
      passiveInputs = _getAudioNodeConnecti.passiveInputs;

  var _getAudioNodeConnecti2 = getAudioNodeConnections(source),
      outputs = _getAudioNodeConnecti2.outputs;

  var eventListeners = getEventListenersOfAudioNode(source);

  var eventListener = function eventListener(type) {
    var nativeDestinationAudioNode = getNativeAudioNode(destination);
    var nativeSourceAudioNode = getNativeAudioNode(source);

    if (type === 'active') {
      var partialConnection = deletePassiveInputConnectionToAudioNode(passiveInputs, source, output, input);
      addActiveInputConnectionToAudioNode(activeInputs, source, partialConnection, false);
      connectNativeAudioNodeToNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output, input);

      if (isPassiveAudioNode(destination)) {
        setInternalState(destination, 'active');
      }
    } else if (type === 'passive') {
      var _partialConnection = deleteActiveInputConnectionToAudioNode(activeInputs, source, output, input);

      addPassiveInputConnectionToAudioNode(passiveInputs, input, _partialConnection, false);
      disconnectNativeAudioNodeFromNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output, input);

      if (isActiveAudioNode(destination)) {
        setInternalStateToPassiveWhenNecessary(destination, activeInputs);
      }
    }
  };

  eventListeners.add(eventListener);

  if (isActiveAudioNode(source)) {
    addActiveInputConnectionToAudioNode(activeInputs, source, [output, input, eventListener], true);
  } else {
    addPassiveInputConnectionToAudioNode(passiveInputs, input, [source, output, eventListener], true);
  }

  insertElementInSet(outputs, [destination, output, input], function (outputConnection) {
    return outputConnection[0] === destination && outputConnection[1] === output && outputConnection[2] === input;
  }, true);
};

var addConnectionToAudioNodeOfOfflineAudioContext = function addConnectionToAudioNodeOfOfflineAudioContext(source, destination, output, input) {
  var _getAudioNodeConnecti3 = getAudioNodeConnections(destination),
      activeInputs = _getAudioNodeConnecti3.activeInputs;

  var _getAudioNodeConnecti4 = getAudioNodeConnections(source),
      outputs = _getAudioNodeConnecti4.outputs;

  addActiveInputConnectionToAudioNode(activeInputs, source, [output, input, null], true);
  insertElementInSet(outputs, [destination, output, input], function (outputConnection) {
    return outputConnection[0] === destination && outputConnection[1] === output && outputConnection[2] === input;
  }, true);
};

var addConnectionToAudioParamOfAudioContext = function addConnectionToAudioParamOfAudioContext(source, destination, output) {
  var _getAudioParamConnect = getAudioParamConnections(source.context, destination),
      activeInputs = _getAudioParamConnect.activeInputs,
      passiveInputs = _getAudioParamConnect.passiveInputs;

  var _getAudioNodeConnecti5 = getAudioNodeConnections(source),
      outputs = _getAudioNodeConnecti5.outputs;

  var eventListeners = getEventListenersOfAudioNode(source);

  var eventListener = function eventListener(type) {
    var nativeAudioNode = getNativeAudioNode(source);
    var nativeAudioParam = getNativeAudioParam(destination);

    if (type === 'active') {
      var partialConnection = deletePassiveInputConnectionToAudioParam(passiveInputs, source, output);
      addActiveInputConnectionToAudioParam(activeInputs, source, partialConnection, false);
      nativeAudioNode.connect(nativeAudioParam, output);
    } else if (type === 'passive') {
      var _partialConnection2 = deleteActiveInputConnectionToAudioParam(activeInputs, source, output);

      addPassiveInputConnectionToAudioParam(passiveInputs, _partialConnection2, false);
      nativeAudioNode.disconnect(nativeAudioParam, output);
    }
  };

  eventListeners.add(eventListener);

  if (isActiveAudioNode(source)) {
    addActiveInputConnectionToAudioParam(activeInputs, source, [output, eventListener], true);
  } else {
    addPassiveInputConnectionToAudioParam(passiveInputs, [source, output, eventListener], true);
  }

  insertElementInSet(outputs, [destination, output], function (outputConnection) {
    return outputConnection[0] === destination && outputConnection[1] === output;
  }, true);
};

var addConnectionToAudioParamOfOfflineAudioContext = function addConnectionToAudioParamOfOfflineAudioContext(source, destination, output) {
  var _getAudioParamConnect2 = getAudioParamConnections(source.context, destination),
      activeInputs = _getAudioParamConnect2.activeInputs;

  var _getAudioNodeConnecti6 = getAudioNodeConnections(source),
      outputs = _getAudioNodeConnecti6.outputs;

  addActiveInputConnectionToAudioParam(activeInputs, source, [output, null], true);
  insertElementInSet(outputs, [destination, output], function (outputConnection) {
    return outputConnection[0] === destination && outputConnection[1] === output;
  }, true);
};

var deleteActiveInputConnection = function deleteActiveInputConnection(activeInputConnections, source, output) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = activeInputConnections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var activeInputConnection = _step.value;

      if (activeInputConnection[0] === source && activeInputConnection[1] === output) {
        activeInputConnections.delete(activeInputConnection);
        return activeInputConnection;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
};

var deleteInputConnectionOfAudioNode = function deleteInputConnectionOfAudioNode(source, destination, output, input) {
  var _getAudioNodeConnecti7 = getAudioNodeConnections(destination),
      activeInputs = _getAudioNodeConnecti7.activeInputs,
      passiveInputs = _getAudioNodeConnecti7.passiveInputs;

  var activeInputConnection = deleteActiveInputConnection(activeInputs[input], source, output);

  if (activeInputConnection === null) {
    var passiveInputConnection = deletePassiveInputConnectionToAudioNode(passiveInputs, source, output, input);
    return [passiveInputConnection[2], 'passive'];
  }

  return [activeInputConnection[2], 'active'];
};

var deleteInputConnectionOfAudioParam = function deleteInputConnectionOfAudioParam(source, destination, output) {
  var _getAudioParamConnect3 = getAudioParamConnections(source.context, destination),
      activeInputs = _getAudioParamConnect3.activeInputs,
      passiveInputs = _getAudioParamConnect3.passiveInputs;

  var activeInputConnection = deleteActiveInputConnection(activeInputs, source, output);

  if (activeInputConnection === null) {
    var passiveInputConnection = deletePassiveInputConnectionToAudioParam(passiveInputs, source, output);
    return [passiveInputConnection[1], 'passive'];
  }

  return [activeInputConnection[2], 'active'];
};

var deleteInputsOfAudioNode = function deleteInputsOfAudioNode(source, destination, output, input) {
  var _deleteInputConnectio = deleteInputConnectionOfAudioNode(source, destination, output, input),
      _deleteInputConnectio2 = _slicedToArray(_deleteInputConnectio, 2),
      listener = _deleteInputConnectio2[0],
      internalState = _deleteInputConnectio2[1];

  if (listener !== null) {
    deleteEventListenerOfAudioNode(source, listener);

    if (internalState === 'active') {
      disconnectNativeAudioNodeFromNativeAudioNode(getNativeAudioNode(source), getNativeAudioNode(destination), output, input);
    }
  }

  if (isActiveAudioNode(destination)) {
    var _getAudioNodeConnecti8 = getAudioNodeConnections(destination),
        activeInputs = _getAudioNodeConnecti8.activeInputs;

    setInternalStateToPassiveWhenNecessary(destination, activeInputs);
  }
};

var deleteInputsOfAudioParam = function deleteInputsOfAudioParam(source, destination, output) {
  var _deleteInputConnectio3 = deleteInputConnectionOfAudioParam(source, destination, output),
      _deleteInputConnectio4 = _slicedToArray(_deleteInputConnectio3, 2),
      listener = _deleteInputConnectio4[0],
      internalState = _deleteInputConnectio4[1];

  if (listener !== null) {
    deleteEventListenerOfAudioNode(source, listener);

    if (internalState === 'active') {
      getNativeAudioNode(source).disconnect(getNativeAudioParam(destination), output);
    }
  }
};

var deleteAnyConnection = function deleteAnyConnection(source) {
  var audioNodeConnectionsOfSource = getAudioNodeConnections(source);
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = audioNodeConnectionsOfSource.outputs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var outputConnection = _step2.value;

      if (isAudioNodeOutputConnection(outputConnection)) {
        deleteInputsOfAudioNode.apply(void 0, [source].concat(_toConsumableArray(outputConnection)));
      } else {
        deleteInputsOfAudioParam.apply(void 0, [source].concat(_toConsumableArray(outputConnection)));
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  audioNodeConnectionsOfSource.outputs.clear();
};

var deleteConnectionAtOutput = function deleteConnectionAtOutput(source, output) {
  var audioNodeConnectionsOfSource = getAudioNodeConnections(source);
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = audioNodeConnectionsOfSource.outputs[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var outputConnection = _step3.value;

      if (outputConnection[1] === output) {
        if (isAudioNodeOutputConnection(outputConnection)) {
          deleteInputsOfAudioNode.apply(void 0, [source].concat(_toConsumableArray(outputConnection)));
        } else {
          deleteInputsOfAudioParam.apply(void 0, [source].concat(_toConsumableArray(outputConnection)));
        }

        audioNodeConnectionsOfSource.outputs.delete(outputConnection);
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }
};

var deleteConnectionToDestination = function deleteConnectionToDestination(source, destination, output, input) {
  var audioNodeConnectionsOfSource = getAudioNodeConnections(source);
  return Array.from(audioNodeConnectionsOfSource.outputs).filter(function (outputConnection) {
    return outputConnection[0] === destination && (output === undefined || outputConnection[1] === output) && (input === undefined || outputConnection[2] === input);
  }).reduce(function (numberOfDeletedConnections, outputConnection) {
    if (isAudioNodeOutputConnection(outputConnection)) {
      deleteInputsOfAudioNode.apply(void 0, [source].concat(_toConsumableArray(outputConnection)));
    } else {
      deleteInputsOfAudioParam.apply(void 0, [source].concat(_toConsumableArray(outputConnection)));
    }

    audioNodeConnectionsOfSource.outputs.delete(outputConnection);
    return numberOfDeletedConnections + 1;
  }, 0);
};

export var createAudioNodeConstructor = function createAudioNodeConstructor(createIndexSizeError, createInvalidAccessError, createNotSupportedError, isNativeOfflineAudioContext) {
  return (
    /*#__PURE__*/
    function (_EventTarget) {
      _inherits(AudioNode, _EventTarget);

      function AudioNode(context, internalState, nativeAudioNode, audioNodeRenderer) {
        var _this;

        _classCallCheck(this, AudioNode);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(AudioNode).call(this, nativeAudioNode));
        _this._context = context;
        _this._nativeAudioNode = nativeAudioNode;
        var nativeContext = getNativeContext(context); // Bug #12: Safari does not support to disconnect a specific destination.
        // @todo Make sure this is not used with an OfflineAudioContext.

        if (!isNativeOfflineAudioContext(nativeContext) && true !== cacheTestResult(testAudioNodeDisconnectMethodSupport, function () {
          return testAudioNodeDisconnectMethodSupport(nativeContext);
        })) {
          wrapAudioNodeDisconnectMethod(nativeAudioNode);
        }

        if (internalState === 'active') {
          ACTIVE_AUDIO_NODE_STORE.add(_assertThisInitialized(_this));
        }

        AUDIO_NODE_STORE.set(_assertThisInitialized(_this), nativeAudioNode);
        EVENT_LISTENERS.set(_assertThisInitialized(_this), new Set());
        addAudioNode(context, _assertThisInitialized(_this), audioNodeRenderer, nativeAudioNode);
        return _this;
      }

      _createClass(AudioNode, [{
        key: "connect",
        value: function connect(destination) {
          var output = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var input = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          var nativeContext = getNativeContext(this._context);
          var isOffline = isNativeOfflineAudioContext(nativeContext);

          var detectCycles = function detectCycles(source, dstntn) {
            var audioNodeOfDestination = isAudioNode(dstntn) ? dstntn : getValueForKey(AUDIO_PARAM_AUDIO_NODE_STORE, dstntn);

            if (source === audioNodeOfDestination) {
              throw createNotSupportedError();
            }

            if (isDelayNode(audioNodeOfDestination)) {
              return;
            }

            var _getAudioNodeConnecti9 = getAudioNodeConnections(audioNodeOfDestination),
                outputs = _getAudioNodeConnecti9.outputs;

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = outputs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var outputConnection = _step4.value;
                detectCycles(source, outputConnection[0]);
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          };

          if (isAudioNode(destination)) {
            var nativeDestinationAudioNode = getNativeAudioNode(destination);

            try {
              var connection = connectNativeAudioNodeToNativeAudioNode(this._nativeAudioNode, nativeDestinationAudioNode, output, input);

              if (isOffline || isPassiveAudioNode(this)) {
                var _this$_nativeAudioNod;

                (_this$_nativeAudioNod = this._nativeAudioNode).disconnect.apply(_this$_nativeAudioNod, _toConsumableArray(connection));
              } else if (isPassiveAudioNode(destination)) {
                setInternalState(destination, 'active');
              } // An AudioWorklet needs a connection because it otherwise may truncate the input array.
              // @todo Count the number of connections which depend on this auxiliary GainNode to know when it can be removed again.


              if (isAudioWorkletNode(destination)) {
                var auxiliaryGainNodes = AUXILIARY_GAIN_NODE_STORE.get(nativeDestinationAudioNode);

                if (auxiliaryGainNodes === undefined) {
                  var nativeGainNode = nativeContext.createGain();
                  nativeGainNode.connect(connection[0], 0, connection[2]);
                  AUXILIARY_GAIN_NODE_STORE.set(nativeDestinationAudioNode, new Map([[input, nativeGainNode]]));
                } else if (auxiliaryGainNodes.get(input) === undefined) {
                  var _nativeGainNode = nativeContext.createGain();

                  _nativeGainNode.connect(connection[0], 0, connection[2]);

                  auxiliaryGainNodes.set(input, _nativeGainNode);
                }
              }
            } catch (err) {
              // Bug #41: Only Chrome, Firefox and Opera throw the correct exception by now.
              if (err.code === 12) {
                throw createInvalidAccessError();
              }

              throw err; // tslint:disable-line:rxjs-throw-error
            }

            detectCycles(this, destination);

            if (isOffline) {
              addConnectionToAudioNodeOfOfflineAudioContext(this, destination, output, input);
            } else {
              addConnectionToAudioNodeOfAudioContext(this, destination, output, input);
            }

            return destination;
          }

          var nativeAudioParam = getNativeAudioParam(destination);
          /*
           * Bug #147 & #153: Safari does not support to connect an input signal to the playbackRate AudioParam of an
           * AudioBufferSourceNode. This can't be easily detected and that's why the outdated name property is used here to identify
           * Safari.
           */

          if (nativeAudioParam.name === 'playbackRate') {
            throw createNotSupportedError();
          }

          try {
            this._nativeAudioNode.connect(nativeAudioParam, output);

            if (isOffline || isPassiveAudioNode(this)) {
              this._nativeAudioNode.disconnect(nativeAudioParam, output);
            }
          } catch (err) {
            // Bug #58: Only Firefox does throw an InvalidStateError yet.
            if (err.code === 12) {
              throw createInvalidAccessError();
            }

            throw err; // tslint:disable-line:rxjs-throw-error
          }

          detectCycles(this, destination);

          if (isOffline) {
            addConnectionToAudioParamOfOfflineAudioContext(this, destination, output);
          } else {
            addConnectionToAudioParamOfAudioContext(this, destination, output);
          }
        }
      }, {
        key: "disconnect",
        value: function disconnect(destinationOrOutput, output, input) {
          if (destinationOrOutput === undefined) {
            deleteAnyConnection(this);
          } else if (typeof destinationOrOutput === 'number') {
            if (destinationOrOutput < 0 || destinationOrOutput >= this.numberOfOutputs) {
              throw createIndexSizeError();
            }

            deleteConnectionAtOutput(this, destinationOrOutput);
          } else {
            if (output !== undefined && (output < 0 || output >= this.numberOfOutputs)) {
              throw createIndexSizeError();
            }

            if (isAudioNode(destinationOrOutput) && input !== undefined && (input < 0 || input >= destinationOrOutput.numberOfInputs)) {
              throw createIndexSizeError();
            }

            if (deleteConnectionToDestination(this, destinationOrOutput, output, input) === 0) {
              throw createInvalidAccessError();
            }
          }
        }
      }, {
        key: "channelCount",
        get: function get() {
          return this._nativeAudioNode.channelCount;
        },
        set: function set(value) {
          this._nativeAudioNode.channelCount = value;
        }
      }, {
        key: "channelCountMode",
        get: function get() {
          return this._nativeAudioNode.channelCountMode;
        },
        set: function set(value) {
          this._nativeAudioNode.channelCountMode = value;
        }
      }, {
        key: "channelInterpretation",
        get: function get() {
          return this._nativeAudioNode.channelInterpretation;
        },
        set: function set(value) {
          this._nativeAudioNode.channelInterpretation = value;
        }
      }, {
        key: "context",
        get: function get() {
          return this._context;
        }
      }, {
        key: "numberOfInputs",
        get: function get() {
          return this._nativeAudioNode.numberOfInputs;
        }
      }, {
        key: "numberOfOutputs",
        get: function get() {
          return this._nativeAudioNode.numberOfOutputs;
        }
      }]);

      return AudioNode;
    }(EventTarget)
  );
};